import { IMeilisearchResponse } from '../../../interfaces/Element.interfaces';
import { createURLSearchParams } from '../../../utils/creator/createURLSearchParams.util';
import { meiliAxios } from '../../common/meiliAxios';

export interface IGetUserSellTractorSearchParams {
  q: string;
  limit?: number;
  offset?: number;
}

// Meilisearch에서 반환하는 직거래 매물 검색 데이터 구조
export interface IUserSellTractorSearchData {
  id: string;
  code?: string;
  brand?: {
    id: string;
    name: string;
  };
  machine?: {
    id: string;
    model: string;
    machineType: string;
    imageMain: string;
    engineOutputInPs?: number;
    rowConfig?: string | null;
  };
  modelImage?: string; // 매물 이미지
  engineOutputInPs?: number; // 마력
  rowConfig?: string | null; // 조식
  seller?: {
    id: string;
    name: string;
    nickname: string;
    phoneNumber: string;
  };
  manufacturedYear?: number;
  operationTime?: number;
  hopeSellingPrice?: number;
  location?: string;
  status?: string;
  approvalStatus?: string;
  views?: number;
  inquiryCount?: number; // 문의 횟수
  pokeCount?: number; // 찔러보기 횟수
  priceNegotiationYn?: boolean; // 가격 협상 가능 여부
  createdAt?: string;
  updatedAt?: string;
}

export interface IUseGetUserSellTractorSearchDataReturn extends IMeilisearchResponse {
  hits: IUserSellTractorSearchData[];
}

export const getUserSellTractorSearchData = (
  searchParam: IGetUserSellTractorSearchParams,
): Promise<IUseGetUserSellTractorSearchDataReturn> => {
  const urlSearchParams = createURLSearchParams(searchParam);

  const indexUid = (() => {
    switch (process.env.REACT_APP_CLIENT_ENVIRONMENT) {
      case 'production':
        return 'market_user_sell_tractors';
      case 'staging':
        return 'market_user_sell_tractors_stage';
      default:
        return 'market_user_sell_tractors_dev';
    }
  })();

  return meiliAxios.get(`/indexes/${indexUid}/search?${urlSearchParams}`);
};
